<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import { getKennungValueDisplay, getKennungValue } from "@/DataHelper";
// import SoftTermProjektstundenUebersicht from "@/views/SoftTerm/Projektstunden/Uebersicht.vue";
import { getSiteData } from "@/NavigationHelper";
import { mountedBase, BaseSetup, onSave } from "@/DataLoaderStatic";

const emit = defineEmits(["back"]);
const myHeight = ref<number>(window.innerHeight - 200);
let day = ref<Date>(AUApi.Current.zeitbereich.von);
let vonAnzeige = ref<string>("");
let bisAnzeige = ref<string>("");
let stdAnzeige = ref<string>("");
let std: number = 0;
let initalized = ref<boolean>(false);
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "ZE_Stunden_Projektsstunden",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));

onMounted(async () => {
  initalized.value = false;
  const siteData = getSiteData();
  if (siteData) {
    if (siteData.zeitbereich) {
      pageParams.zeitbereich = siteData.zeitbereich;
      day.value = siteData.zeitbereich.von;
    }
  } else {
    day.value = AUApi.Current.zeitbereich.von;
  }
  if (siteData && siteData.aic) {
    pageParams.aic = siteData.aic;
  }
  await mountedBase(uiData, pageParams, false);
  if (!uiData.showLoading && uiData.data) {
    const row = uiData.data[0];
    stdAnzeige.value = getKennungValueDisplay(row, "verteilbareStd", uiData.columns);
    std = getKennungValue(uiData.data[0], "verteilbareStd", uiData.columns);
    vonAnzeige.value = getKennungValueDisplay(row, "FIRST_IN", uiData.columns);
    bisAnzeige.value = getKennungValueDisplay(row, "LAST_OUT", uiData.columns);
  }
  uiData.showLoading = false;
  uiData.initialized = true;
  initalized.value = true;
});
</script>
<template>
  <SoftTermProjektstundenUebersicht
    v-if="day != null && initalized && uiData.initialized"
    ref="timelines"
    :day="day"
    :showError="true"
    :vonAnzeige="vonAnzeige"
    :bisAnzeige="bisAnzeige"
    :stdAnzeige="stdAnzeige"
    :std="std"
    :zeitbereich="pageParams.zeitbereich"
    :contentHeight="myHeight"
    :aic="pageParams.aic"
  ></SoftTermProjektstundenUebersicht>
</template>
